import React from 'react'
import { ArrowLeft } from 'lucide-react'

const Header = () => {
  return (
    <header className="bg-background-card/90 backdrop-blur-md sticky top-0 z-50">
      <div className="max-w-[1020px] mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Bouton retour */}
          <a
            href="https://alexandreguilloteau.fr/projects"
            className="btn btn-secondary"
            aria-label="Retour"
          >
            <ArrowLeft size={20} />
          </a>

          {/* Titre centré */}
          <h1 className="text-lg font-bold text-text-primary mb-0 absolute left-1/2 transform -translate-x-1/2">
            Podcast Search
          </h1>

          {/* Espace vide pour équilibrer */}
          <div className="w-12"></div>
        </div>
      </div>
    </header>
  )
}

export default React.memo(Header) 